import { createSelector } from 'reselect';
import RouteModificationTransactionsHistoryColumns from '../../containers/RouteModificationTransactionsHistoryColumns';
import TableDefinitions from '../../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.ROUTE_MODIFICATION_TRANSACTIONS_HISTORY.isLoading;
export const getData = TableDefinitions.ROUTE_MODIFICATION_TRANSACTIONS_HISTORY.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.global.assetType.appContext,
  RouteModificationTransactionsHistoryColumns,
);
